import React from 'react';

export const DeletePermitActivityFeedItemDescription = props => {
    const {CustomEventData, Event} = props;

    return <p>
        {Event?.Activity?.User?.name} removed a {CustomEventData?.permitType} from {CustomEventData?.permitOrg} permit
        on {CustomEventData?.title}.
    </p>;
};



